/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetWebsitImageConfigSortListRespVo } from './GetWebsitImageConfigSortListRespVo';
import {
    GetWebsitImageConfigSortListRespVoFromJSON,
    GetWebsitImageConfigSortListRespVoFromJSONTyped,
    GetWebsitImageConfigSortListRespVoToJSON,
    GetWebsitImageConfigSortListRespVoToJSONTyped,
} from './GetWebsitImageConfigSortListRespVo';

/**
 * 
 * @export
 * @interface ResponseListGetWebsitImageConfigSortListRespVo
 */
export interface ResponseListGetWebsitImageConfigSortListRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListGetWebsitImageConfigSortListRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListGetWebsitImageConfigSortListRespVo
     */
    message?: string;
    /**
     * 
     * @type {Array<GetWebsitImageConfigSortListRespVo>}
     * @memberof ResponseListGetWebsitImageConfigSortListRespVo
     */
    data?: Array<GetWebsitImageConfigSortListRespVo>;
}

/**
 * Check if a given object implements the ResponseListGetWebsitImageConfigSortListRespVo interface.
 */
export function instanceOfResponseListGetWebsitImageConfigSortListRespVo(value: object): value is ResponseListGetWebsitImageConfigSortListRespVo {
    return true;
}

export function ResponseListGetWebsitImageConfigSortListRespVoFromJSON(json: any): ResponseListGetWebsitImageConfigSortListRespVo {
    return ResponseListGetWebsitImageConfigSortListRespVoFromJSONTyped(json, false);
}

export function ResponseListGetWebsitImageConfigSortListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListGetWebsitImageConfigSortListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(GetWebsitImageConfigSortListRespVoFromJSON)),
    };
}

export function ResponseListGetWebsitImageConfigSortListRespVoToJSON(json: any): ResponseListGetWebsitImageConfigSortListRespVo {
    return ResponseListGetWebsitImageConfigSortListRespVoToJSONTyped(json, false);
}

export function ResponseListGetWebsitImageConfigSortListRespVoToJSONTyped(value?: ResponseListGetWebsitImageConfigSortListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(GetWebsitImageConfigSortListRespVoToJSON)),
    };
}

